<template>
<div>
        <div class="dam columns">
        <h2>大坝自动化监测</h2>
        <div class="all">
          <p>
              大坝与人们生产生活息息相关，大坝安全问题越来越受到广泛的关注,其安全监测意义重大。因大坝的运行性态将随着运行时间的增 长而更趋复杂，为确保大坝的高效，安全运行，适应现代运行管理的要求，满足大坝安全监测快速反馈和远程管理，实现大坝安全 监测自动化是水库运行管理不二的选择和必由之路。
          </p>
        </div>
        <div class="brief_box">

            <div class="title_box row">
                <div class="blue_line"></div>
                <h5>项目基本情况</h5>
            </div>
            <p>监测坝体结构形变、受力、开裂和渗水情况，分析坝体健康状况， 为坝体的健康维护提供依据和支持</p>
             
              <div class="title_box row">
                <div class="blue_line"></div>
                <h5>监测参数</h5>
            </div>
            <p>表面位移（GNSS/测量机器人）</p>
            <p>坝基沉降（测量机器人/静力水准</p>
            <p>坝体渗流（渗压计）</p>
            <p>深层位移（多点位移计）</p>
            <p>接缝/裂缝（测缝计）</p>
            <p>应力（钢筋计/锚索计）</p>
            <p>堰槽水位（量水堰计）</p>
            <p>气象环境（气象站）</p>
            <p>引张线（引张线仪）</p>
            <p>地震（加速度计</p>

            <div class="title_box row">
                <div class="blue_line"></div>
                <h5>推荐设备</h5>
            </div>
            <p>监测设备：</p>
            <p>RocBox RT2000-GS北斗监测GNSS</p>
            <p>Topcon MS系列测量机器人</p>
            <p>Topcon DS系列测量机器人</p>
            <p>RT-DT-5100液压式静力水准</p>
            <p> RT-VW-3100振弦式渗压计</p>
            <p>RT-VW-4300振弦式多点位移计</p>
            <p>RT-VW-4100振弦式裂缝计</p>
            <p>RT-VW-2300振弦式钢筋计</p>
            <p>RT-DT-3300磁致式量水堰计</p>
            
            <h6>监测终端:</h6>
            <p>RocBox RT2000监测终端</p> 
            <p>RocMIoT监测物联网系列产品</p>  
            <p>振动信号采集仪</p>                
        </div>    
    </div>
     <foot></foot>

</div>

</template>
<style>
.dam {
  width: 100%;
  background-color: rgba(245, 245, 245, 1);
}
h2 {
  font-size: 0.36rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  margin-top: 0.55rem;
  margin-bottom: 0.36rem;
}
.all {
  width: 11.4rem;
  height: 0.4rem;
  background: rgba(255, 255, 255, 1);
  border: 0.01rem solid rgba(221, 221, 221, 1);
  margin: 0 auto;
  padding: 0.3rem;
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 106, 117, 1);
}
.brief_box {
  width: 12rem;
  background: rgba(255, 255, 255, 1);
  border: 0.01rem solid rgba(221, 221, 221, 1);
  margin-top: 0.2rem;
  margin-bottom: 0.67rem;
  padding-bottom: .64rem;
}
.brief_box p,
 .brief_box h6{
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 106, 117, 1);
  padding-left: 0.4rem;
  padding-top: 0.1rem;
}
.brief_box h6{
    padding-top: .3rem;
}
.title_box {
  margin-left: 0.4rem;
  margin-top: 0.37rem;
  font-size: 0.16rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  line-height: 0.2rem;
}
.blue_line {
  width: 0.03rem;
  height: 0.2rem;
  background: rgba(67, 148, 208, 1);
  margin-right: 0.1rem;
}
</style>

<script>
import footer from "../../common/footer";
export default {
  data() {
    return {};
  },
  components: {
    foot: footer
  }
};
</script>




// WEBPACK FOOTER //
// src/homepages/solutionpage/dam.vue